import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles, theme as defaultTheme } from '@ui-library/sl';

const Layout = ({ children }) => (
  <ThemeProvider theme={defaultTheme}>
    <>
      <GlobalStyles />
      {children}
    </>
  </ThemeProvider>
);

export default Layout;
